export const SETTINGS_TAB_PARAM = 'tab';

export const SETTINGS_TABS = ['general', 'usage', 'profile', 'security', 'sessions'] as const;

export type SettingsTab = (typeof SETTINGS_TABS)[number];

/**
 * Résout l'onglet actif de `/settings` à partir du paramètre d'URL.
 *
 * L'onglet « Général » porte la configuration de l'assistant : il est réservé
 * aux administrateurs plateforme et aux `owner`/`admin` d'entreprise. Une
 * demande explicite de `general` sans droit retombe sur `profile`, de sorte
 * qu'un lien partagé ne révèle jamais la surface à un membre.
 */
export function resolveSettingsTab({
  canSeeGeneralTab,
  requested,
}: {
  canSeeGeneralTab: boolean;
  requested: string | null;
}): SettingsTab {
  const fallback: SettingsTab = canSeeGeneralTab ? 'general' : 'profile';
  const isKnownTab = (value: string): value is SettingsTab =>
    (SETTINGS_TABS as readonly string[]).includes(value);

  if (!requested || !isKnownTab(requested)) {
    return fallback;
  }

  if (requested === 'general' && !canSeeGeneralTab) {
    return 'profile';
  }

  return requested;
}
